import { createContext } from "react";

const pfContext=createContext("");

export default pfContext;